'use strict';

exports.__esModule = true;

var _freeze = require('babel-runtime/core-js/object/freeze');

var _freeze2 = _interopRequireDefault(_freeze);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Converts raw API attributes into a User specific object
 */
function userModel(attrs) {
  if (!_config2.default.models) {
    return attrs;
  }

  var user = (0, _assign2.default)({}, attrs);

  return (0, _freeze2.default)(user);
}

exports.default = userModel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/models/user.js
// module id = 1073
// module chunks = 0